module.exports = __webpack_public_path__ + "static/media/Material-Icons.3adb4bf1.svg";